// Entry point of a tiny bundle that loads first and starts requests for assets
// like fonts. Speeds up page loading by allowing these assets to load in
// parallel with the other much larger bundles. See T5951.

// The base URL to use as a prefix for assets. Needed because baeditor's
// previews need to load assets from a different server.
//
// BAEditor hosts look like aopstest1.com / aopstest2.com (digits required).
// `\d*` was wrong: it also matched bare `aopstest.com` and k8s hosts like
// `ba-limbo.aopstest.com`, which made IS_ON_BAEDITOR true, skipped React
// mount, and pointed BASE_URL at krakentest.
global.IS_ON_BAEDITOR =
	window.location.hostname.indexOf("aops.com") > -1 ||
	window.location.hostname.indexOf("artofproblemsolving.com") > -1 ||
	/aopstest\d+\.com/.test(window.location.hostname);
// More info on how to point BAEditor at new server here https://docs.google.com/document/d/1CrNgYu44hYV5bHMotgvS7wXBrQM870pM_hHMjsCM16w/edit
// Must be hard-coded since this code is run on baeditor.
global.BASE_URL = global.IS_ON_BAEDITOR ? "//krakentest.com/" : "/";

if (!global.BA_DIST_PATH) global.BA_DIST_PATH = "/dist/latest/";

// Helper for computing the URL to use for resources loaded from dist, given
// the BASE_URL and BA_DIST_PATH globals have been set.
// TODO: Is global the best thing to do here? It's needed by this init file
// which can't require much else in src...
global.getDistURL = function(name) {
	let distPath = global.BA_DIST_PATH;
	// If BA_DIST_PATH begins with a /, remove the / and put the BASE_URL in front.
	if (distPath && /^\//.test(distPath)) {
		distPath = global.BASE_URL + distPath.substr(1);
	}
	return distPath + name;
};

const importantFonts = ["Roboto:n4", "Roboto Slab:n4"];
const backgroundFonts = [
	"Roboto:n4,i4,n7,i7",
	"Roboto Slab:n4,n7",
	"BAOnlineIcons",
	"lizzie",
	"grogg",
	"BAOnlineClock",
	"Lora:i4,i7",
];

let webFontsDone = false;
const webFontsCallbacksPending = [];

global.waitForWebFonts = function(cb) {
	if (webFontsDone) {
		setTimeout(cb, 0);
	} else {
		webFontsCallbacksPending.push(cb);
	}
};

const onFontsDone = () => {
	// Load more fonts in the background
	WebFont.load({
		custom: {
			families: backgroundFonts,
			testStrings: {
				lizzie: "A1",
				grogg: "A1",
				Lora: "A1",
			},
		},
	});

	webFontsDone = true;
	webFontsCallbacksPending.forEach(f => f());
};

const WebFont = require("webfontloader");
WebFont.load({
	custom: {
		families: importantFonts,
		urls: [global.getDistURL("font.css")],
	},
	active: onFontsDone,
	inactive: onFontsDone,
	timeout: 1000,
});

// Preloading images is currently disabled. Old code:
// const loadImages = function(cb) {
//   const pageUrl = window.location.pathname;
//   const initialImages = PreloadList.getImmediateImages(global.BASE_URL, pageUrl);
//   ImageLoader.preload(initialImages, true, cb);
// };

// and code that was alongside the startReact call:
// ImageLoader.preload(PreloadList.getAllImages(global.BASE_URL), true);
